import { Box, Typography } from '@mui/material';
import { CustomDialog, dialogStyles } from '@src/components/dialogs/maxBookingAttemptsDialog/MaxBookingAttemptsDialog.styles';
type MaxBookingAttemptsDialogProps = {
  open: boolean;
  onClose: () => void;
};
const MaxBookingAttemptsDialog = ({
  open,
  onClose
}: MaxBookingAttemptsDialogProps) => {
  return <CustomDialog open={open} onClose={onClose} data-sentry-element="CustomDialog" data-sentry-component="MaxBookingAttemptsDialog" data-sentry-source-file="MaxBookingAttemptsDialog.tsx">
			<Box sx={dialogStyles.dialogContent} data-sentry-element="Box" data-sentry-source-file="MaxBookingAttemptsDialog.tsx">
				<Typography variant="header2" sx={dialogStyles.title} data-sentry-element="Typography" data-sentry-source-file="MaxBookingAttemptsDialog.tsx">
					We&apos;re here to help!
				</Typography>
				<Typography variant="bodyMediumBook" data-sentry-element="Typography" data-sentry-source-file="MaxBookingAttemptsDialog.tsx">
					To book more than 1 appointment, please call (701) 297-2015
				</Typography>
			</Box>
		</CustomDialog>;
};
export default MaxBookingAttemptsDialog;